import Put from "../api/Put";
import { APPOINTMENT_UPDATE } from "../api/Routes";

export const setTimeAppointment = (idCita, userType, isStart, arrVideoCall, auth) =>{
    let index = arrVideoCall.findIndex(el=>el.userType===userType && el.initVideo === isStart);

    if(index < 0){
        let d = {
            id: idCita,
            videoCalls: [{
                id: '',
                initVideo: isStart,
                userType: userType
            }]
        }

        Put({url: APPOINTMENT_UPDATE, data: d, access_token: auth.data.access_token, header: true})
        .then(response=>{
            console.log(response)
        })
        .catch(error=>{
            console.log(error)
        })
    }


    
}